import AssingProviderProps from "../propInterfaces/assignProviderProps";
import UserRequestDTO from "../shared/dtos/userRequestDTO";
import axiosInstance from "../app/axios";

export const assignProviderToUserRequest = async ({
  userRequestId,
  providerId,
}: AssingProviderProps) => {
  const result = await axiosInstance.get(
    `admin/trip/assign/${userRequestId}/${providerId}`,
  );
  return result.data;
};

interface AssingProviderForPackageProps {
  userRequests: UserRequestDTO[];
  providerId: number;
}

export const assignProviderToUserRequests = async ({
  userRequests,
  providerId,
}: AssingProviderForPackageProps) => {
  const result = await axiosInstance.post(
    `admin/trip/assign-multiple/${providerId}`,
    {
      userRequests,
    },
  );
  return result.data;
};
